import NumberInput from "@/components/frontend/ui/form/inputs/number";
import { type FormNumberBlock as FormNumberBlockT } from "@/payload-types";

type FormNumberBlockProps = FormNumberBlockT & {
	containerClassName?: string;
	fieldName?: string;
	fieldError?: string;
};

export const FormNumberBlock: React.FC<FormNumberBlockProps> = ({
	content,
	settings,
	containerClassName,
	fieldName,
	fieldError,
}) => {
	return (
		<NumberInput
			name={fieldName}
			defaultValue={content.default ?? undefined}
			placeholder={content.placeholder}
			label={content.label}
			hideLabel={settings?.hideLabel ?? undefined}
			description={content.description}
			error={fieldError}
			required={content.required ?? false}
			containerClassName={containerClassName}
		/>
	);
};
